import { PresignClinicalDocs } from '~/domain/usecases/clinicalDocs/remote';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import {
  InvalidCredentialsError,
  UnexpectedError,
  BadRequestError,
  NotFound,
} from '~/domain/errors';
import '~/infra/global/variables';

export class RemotePresignClinicalDocs implements PresignClinicalDocs {
  private readonly url: string;

  private readonly httpClient: HttpClient<PresignClinicalDocs.Model>;

  constructor(url: string, httClient: HttpClient<PresignClinicalDocs.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  presign = async (
    params: PresignClinicalDocs.Params,
  ): Promise<PresignClinicalDocs.Model> => {
    console.log('Params presign clinical docs: ', params);
    const httpResponse = await this.httpClient.request({
      url: this.url.replace('{docId}', String(params.docId)),
      method: 'patch',
      body: {
        certificate:
          params.signatureSource === 'VIDAAS' ? undefined : params.certificate,
        signatureSource: params.signatureSource,
      },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      default:
        throw new UnexpectedError();
    }
  };
}
